export default {
  ourLetter: "Our letter",
  restaurantIsClosed: "Restaurant is closed",
  isANewProduct: "Is a new product",
  isVegetarian: "Is vegetarian",
  containsLupin: "Contains lupin",
  containsCelery: "Contains celery",
  containsPeanuts: "Contains peanuts",
  containsCrustacean: "Contains crustacean",
  containsGluten: "Contains gluten",
  containsEgg: "Contains egg",
  containsMilk: "Contains milk",
  containsMustard: "Contains mustard",
  containsFish: "Contains fish",
  containsSesame: "Contains sesame",
  containsSoy: "Contains soy",
  containsSulfite: "Contains sulfite",
  vegetarian: "Vegetarian",
  allergens: "ALLERGENS:",
  lupins: "Lupins",
  celery: "Celery",
  peanuts: "Peanuts",
  crustaceans: "Crustaceans",
  gluten: "Gluten",
  egg: "Egg",
  dairyProducts: "Dairy products",
  mustard: "Mustard",
  fish: "Fish",
  sesame: "Sesame",
  soy: "soy",
  sulfite: "sulfite",
  findProduct: "Find product"
};
